import { useHistory, useLocation } from "react-router-dom";
import { REGION_OPTIONS } from "@ugg/shared/components/Leaderboards/leaderboard-filters";
import DefaultSelect from "@ugg/shared/components/FilterManager/DefaultSelect";
import { getBlockImg, getImg } from "@ugg/shared/utils/region-helpers";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { buildQueryParams } from "@ugg/shared/utils/url-query-params";

interface LeaderboardRegionFilterProps {
  className?: string;
  value: string;
  isMobile?: boolean;
  options?: Array<{
    value: string;
    fullLabel: string;
    label: string;
  }>;
}
export function LeaderboardRegionFilter(props: LeaderboardRegionFilterProps) {
  const { className, value, isMobile, options } = props;
  const history = useHistory();
  const location = useLocation();
  const queryParams = useQueryString();

  const onChange = (selected: { value: string; label: string }) => {
    const search = { ...queryParams };
    delete search.page;
    delete search.user;

    history.push({
      pathname: location.pathname,
      search: buildQueryParams({ ...search, region: selected.value }),
    });
  };

  const formatOptionLabel = ({ value, label, shorthandLabel }: { value: string; label: string; shorthandLabel?: string }) => (
    <div className={`region-option`} key={value}>
      {value === "world" ? (
        <div className="region-img-wrapper">
          <img className={"region-img flag-img"} src={getImg(value)} />
        </div>
      ) : (
        <img src={getBlockImg(value)} />
      )}
      <span style={{ marginLeft: "10px" }}>{shorthandLabel ? shorthandLabel : label}</span>
    </div>
  );

  return (
    <DefaultSelect
      title={"Change Region"}
      group={"region"}
      className={`filter-select filter-select_leaderboard-region ${className}`}
      isMobile={isMobile}
      formatOptionLabel={formatOptionLabel}
      options={options ? options : REGION_OPTIONS}
      onChange={onChange}
      value={value}
      width={100}
      isSearchable={false}
    />
  );
}
